<!--邮箱注册登录-->
<template>
  <div class="">
    <myModal class="sign-login" :visible="visible" centered @close="close($event)">
      <template #cuscloseIcon>
        <div class="custom-close">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M1 1L13 13M13 1L1 13" stroke="#8a9bb7" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
      </template>
      <template #body>
        <div class="email-reward-container" v-if="localContentType == 'def'">
          <!-- 整张切图作为背景 -->
          <img src="@/assets/images/user/email_model.png" alt="" class="bg-img" />

          <!-- 关闭按钮 -->
          <div class="modal-close" @click="close($event)">
            <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
              <path d="M1 1L13 13M13 1L1 13" stroke="#6b7fa0" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>

          <!-- 文字和表单叠在图片下半部分 -->
          <div class="form-overlay">
            <h2 class="main-title">{{ $t("emailLogin") }}</h2>
            <p class="sub-title">{{ $t("emailReward") }}</p>

            <!-- 邮箱输入 -->
            <div class="input-group">
              <input
                  v-model="emailAccount"
                  type="email"
                  :placeholder="$t('pleaseInputEmailAccount') || 'Enter your email'"
                  class="email-input"
                  @keyup.enter="sendVerify()"
              />
            </div>

            <!-- 验证码输入 + SEND 按钮 -->
            <div class="input-group code-group">
              <input
                  v-model="verifyCode"
                  type="text"
                  :placeholder="$t('verifCode') || 'Code sent'"
                  class="code-input"
                  @keyup.enter="emailVerifyLogin"
              />
              <button
                  class="send-btn"
                  :class="{ 'send-btn-disabled': isSend || isDisableSend }"
                  :disabled="isSend || isDisableSend"
                  @click="sendVerify()"
              >
                {{ codeTime(countdown) || $t("send") || "SEND" }}
              </button>
            </div>

            <!-- CLAIM 按钮 -->
            <button class="claim-btn" @click="emailVerifyLogin">
              {{ $t("loginLarge") || "EMAIL lOGIN" }}
            </button>
          </div>
        </div>
      </template>
    </myModal>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import showNotice from "@/components/common/notice/notice.js";
import $api from "@/api/index.js";
import $store from "@/store";
import handleResponse from "@/utils/handleResponseData.js";
import i18n from "@/i18n";
import eventEmitter from "@/utils/emitter.js";
import { showRechargeRebateModal } from "@/utils/auth.js";
import {useRouter} from "vue-router";

const { t: $t, locale } = i18n.global;
const userStore = $store("user");
const isTest = import.meta.env.VITE_SHOW_TESTPAGE === "true";
const router = useRouter();
const props = defineProps({
  visible: {
    type: Boolean,
    desc: "登录弹框开关",
    default: !false,
  },
  title: {
    type: String,
    desc: "登录弹框标题",
    default: "steam 登录",
  },
  inviteType: {
    type: String,
    desc: "弹框类型==>小企鹅弹框,和freeru弹框",
    default: "",
  },
  contentType: {
    type: String,
    desc: "登录弹框,可选值为 def  reg  reset  email",
    default: "",
  },
});

//登录弹框内容类型 def-默认  reg-注册/找回密码页 email-邮箱验证码/密码登录页
const localContentType = ref(props.contentType);
//弹框标题
const localTitle = ref(props.title);
const emits = defineEmits(["close", "login", "reg", "rest", "email", "click"]);

//登录注册成功后更新站点数据
function LoginSuccessUpdate(res) {
  localStorage.setItem("token", res.access_token);
  showNotice("s", { desc: $t("loginSuccess") });
  //登录成功更新用户数据
  const token = localStorage.getItem("token");
  if (token) {
    userStore.$patch((state) => {
      state.isToken = true;
      if (state.count <= 1) {
        state.count++;
      } else {
        state.count = 1;
      }
    });
    userStore.getUserInfo().then((res) => {
      console.log("登录成功,更新用户数据;", res);
      isClick.value = false;
      showRechargeRebateModal(userStore, $api, handleResponse);
      router.push({
        path: `user`
      });
    });
  }
  //更新数据后关闭登录弹框
  emits("close");
  resetVerify();
}

const isClick = ref(false);

const codeTime = computed(() => {
  return (a) => (a ? a + "s" : isSend.value ? $t("sending") : "");
});
const emailAccount = ref(""); //邮箱地址
const verifyCode = ref(""); //邮箱验证码
const countdown = ref(0);
const isSend = ref(false); //是否已发送验证码(默认未发送)
const isDisableSend = computed(() => {
  if (!emailAccount.value) {
    return true;
  } else {
    return false;
  }
});
const timerVerify = ref("");

function resetVerify() {
  clearInterval(timerVerify.value);
  isSend.value = false;
  countdown.value = 0;
  emailAccount.value = "";
  verifyCode.value = "";
  codeTime.value(countdown.value);
}

//发送验证码
function sendVerify(type) {
  if (!emailAccount.value) {
    return showNotice("f", { desc: $t("noInputAccount") });
  }
  if (isSend.value) {
    return;
  }
  isSend.value = true;

  let is_use = 2; //邮箱注册或登录,传2
  console.log("邮箱验证码 is_use", is_use);

  //发送邮箱验证码
  $api.user
      .sendEmailVerify({ email: emailAccount.value, is_use })
      .then((res) => {
        console.log("发送邮箱验证码", res);
        const resp = handleResponse(res);
        if (!resp) {
          isSend.value = false;
          return console.log("未知错误", res.message);
        }
        if (countdown.value == 0) {
          if (isSend.value) {
            countdown.value = 180;
            timerVerify.value = setInterval(() => {
              countdown.value--;
              if (countdown.value < 1) {
                resetVerify();
              }
            }, 1000);
          }
        }
        showNotice("s", { desc: res.message });
      })
      .catch((err) => {
        console.log("发送邮箱验证码失败", err);
        isSend.value = false;
        showNotice("f", { desc: $t("requireAccept") });
      });
}

//邮箱验证码注册/登录
function emailVerifyLogin() {
  console.log("email Verify register or login");
  if (!emailAccount.value && !verifyCode.value) {
  }

  const params = {
    email: emailAccount.value,
    invite: null,
    verify: verifyCode.value,
    client_id: localStorage.getItem("ga4_client_id"),
  };
  const invite_id = localStorage.getItem("invite_id");
  if (invite_id) {
    params.invite = invite_id;
  }
  console.log("邀请码;", params);
  if (params.invite) {
    console.log("有邀请码");
    $api.user.vemail_login(params).then((res) => {
      console.log("邮箱验证码登录:", res);
      const resp = handleResponse(res);
      if (!resp) return console.log("未知错误", res.message);
      LoginSuccessUpdate(resp);
    });
  } else {
    console.log("无邀请码");
    delete params.invite;
    $api.user.vemail_login(params).then((res) => {
      console.log("邮箱验证码登录:", res);
      const resp = handleResponse(res);
      if (!resp) return console.log("未知错误", res.message);
      LoginSuccessUpdate(resp);
    });
  }
}

//关闭登录弹框
function close(e) {
  e.stopPropagation();
  emits("close");
  resetVerify();
  if (!userStore.isToken) {
    eventEmitter.emit("api:un_auth");
  }
}
</script>

<style lang="scss" scoped>
.sign-login {
  :deep(.ant-modal) {
    width: 440px !important;
    overflow: visible;

    .ant-modal-content {
      background: transparent;
      border: none;
      box-shadow: none;
      overflow: visible;
      padding: 0;
    }

    .ant-modal-close {
      display: none; // 用自定义关闭按钮
    }

    .ant-modal-header {
      display: none;
    }

    .ant-modal-body {
      padding: 0;
      overflow: visible;
    }
  }
}

/* ===== 整体容器 ===== */
.email-reward-container {
  position: relative;
  width: 100%;
}

/* ===== 背景切图：撑满容器 ===== */
.bg-img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 16px;
}

/* ===== 自定义关闭按钮：定位在图片内框右上角 ===== */
.modal-close {
  position: absolute;
  top: 20%;
  right: 14px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(4px);
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.55);

    svg path {
      stroke: #fff;
    }
  }
}

/* ===== 表单叠加层：绝对定位在图片下半区域 ===== */
.form-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 5;
}

.main-title {
  font-size: 20px;
  font-weight: 800;
  color: #e8edf5;
  text-align: center;
  margin: 0 0 4px;
  letter-spacing: -0.2px;
  line-height: 1.3;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
}

.sub-title {
  font-size: 13px;
  font-weight: 400;
  color: #7b8fad;
  text-align: center;
  margin: 0 0 22px;
  line-height: 1.4;
}

/* ===== 输入框通用 ===== */
.input-group {
  width: 100%;
  margin-bottom: 12px;
  position: relative;
}

.email-input,
.code-input {
  width: 100%;
  height: 46px;
  border-radius: 23px;
  border: 1.5px solid rgba(100, 150, 220, 0.2);
  background: rgba(10, 20, 40, 0.6);
  backdrop-filter: blur(6px);
  padding: 0 20px;
  font-size: 14px;
  font-weight: 400;
  color: #e0e6f0;
  outline: none;
  transition: all 0.25s;
  box-sizing: border-box;

  &::placeholder {
    color: rgba(140, 160, 190, 0.45);
    font-weight: 400;
  }

  &:focus {
    border-color: rgba(59, 140, 255, 0.5);
    background: rgba(15, 30, 60, 0.7);
    box-shadow: 0 0 0 3px rgba(59, 140, 255, 0.08);
  }
}

/* ===== 验证码行 ===== */
.code-group {
  position: relative;

  .code-input {
    padding-right: 105px;
  }

  .send-btn {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    height: 38px;
    min-width: 85px;
    padding: 0 18px;
    border-radius: 19px;
    border: 1.5px solid rgba(59, 140, 255, 0.5);
    background: transparent;
    color: #5ba3ff;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.5px;
    cursor: pointer;
    transition: all 0.25s;

    &:hover:not(:disabled) {
      background: rgba(59, 140, 255, 0.1);
      border-color: rgba(59, 140, 255, 0.7);
      color: #7bb8ff;
    }

    &:active:not(:disabled) {
      transform: translateY(-50%) scale(0.97);
    }
  }

  .send-btn-disabled {
    border-color: rgba(100, 120, 150, 0.15);
    color: #3d4a5e;
    cursor: not-allowed;
  }
}

/* ===== CLAIM 按钮 ===== */
.claim-btn {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  border: 1.5px solid rgba(59, 140, 255, 0.3);
  background: linear-gradient(135deg, rgba(20, 55, 130, 0.3) 0%, rgba(25, 70, 160, 0.2) 100%);
  color: #b8d4ff;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.5px;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 4px;

  &:hover {
    border-color: rgba(59, 140, 255, 0.55);
    color: #dce9ff;
    background: linear-gradient(135deg, rgba(25, 65, 150, 0.4) 0%, rgba(30, 80, 180, 0.3) 100%);
    box-shadow: 0 0 18px rgba(59, 140, 255, 0.1);
  }

  &:active {
    transform: scale(0.98);
  }
}

/* ===== 响应式 ===== */
@media screen and (max-width: 500px) {
  .sign-login {
    :deep(.ant-modal) {
      width: 92vw !important;
    }
  }

  .form-overlay {
    padding: 0 20px 24px;
  }

  .main-title {
    font-size: 17px;
  }

  .sub-title {
    font-size: 12px;
    margin-bottom: 16px;
  }

  .email-input,
  .code-input {
    height: 42px;
    font-size: 13px;
  }

  .claim-btn {
    height: 42px;
    font-size: 13px;
  }
}
</style>